(() => {
  const storageKey = 'pearl-product-browse-context-v1';

  const normalizePath = (value) => {
    try {
      return new URL(value, window.location.origin).pathname.replace(/\/$/, '') || '/';
    } catch (_error) {
      return '';
    }
  };

  const readContext = () => {
    try {
      const value = JSON.parse(window.sessionStorage.getItem(storageKey));
      return value && Array.isArray(value.items) ? value : null;
    } catch (_error) {
      return null;
    }
  };

  const writeContext = (value) => {
    try {
      window.sessionStorage.setItem(storageKey, JSON.stringify(value));
    } catch (_error) {
      // Browsing still works with the Liquid collection fallback when storage is unavailable.
    }
  };

  const visibleProductCards = (grid) => Array.from(grid.querySelectorAll('[data-product-card]'))
    .filter((card) => card.getClientRects().length > 0 && card.dataset.productUrl);

  document.addEventListener('click', (event) => {
    const link = event.target.closest('[data-product-card] a[href]');
    if (!link || link.target === '_blank' || event.defaultPrevented) return;

    const destinationPath = normalizePath(link.href);
    if (!destinationPath.includes('/products/')) return;

    const card = link.closest('[data-product-card]');
    const grid = card.closest('.product-grid') || card.parentElement;
    if (!grid) return;

    const cards = visibleProductCards(grid);
    const items = [];
    const seen = new Set();
    cards.forEach((productCard) => {
      const path = normalizePath(productCard.dataset.productUrl);
      if (!path || seen.has(path)) return;
      seen.add(path);
      items.push({
        url: productCard.dataset.productUrl,
        path,
        title: productCard.dataset.productTitle || '',
        anchor: productCard.id || ''
      });
    });

    const currentIndex = items.findIndex((item) => item.path === destinationPath);
    const returnUrl = card.dataset.productSourceUrl || `${window.location.pathname}${window.location.search}`;
    writeContext({
      returnUrl,
      currentPath: destinationPath,
      currentIndex,
      items,
      savedAt: Date.now()
    });
  });

  const detail = document.querySelector('[data-product-detail]');
  if (!detail) return;

  const previousLink = document.querySelector('[data-product-browse-previous]');
  const nextLink = document.querySelector('[data-product-browse-next]');
  document.addEventListener('keydown', (event) => {
    if (event.defaultPrevented || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
    if (event.target.closest?.('input, select, textarea, [contenteditable="true"], [role="tablist"]')) return;

    const destination = event.key === 'ArrowLeft' ? previousLink : event.key === 'ArrowRight' ? nextLink : null;
    if (!destination || destination.hidden) return;
    event.preventDefault();
    destination.click();
  });

  const currentPath = normalizePath(detail.dataset.productUrl || window.location.pathname);
  const context = readContext();
  if (!context || Date.now() - Number(context.savedAt || 0) > 12 * 60 * 60 * 1000) return;

  const currentIndex = context.items.findIndex((item) => item.path === currentPath);
  if (currentIndex < 0) return;

  context.currentPath = currentPath;
  context.currentIndex = currentIndex;
  writeContext(context);

  const currentItem = context.items[currentIndex];
  const returnLink = document.querySelector('[data-product-return-link]');
  if (returnLink && context.returnUrl) {
    const anchor = currentItem?.anchor ? `#${encodeURIComponent(currentItem.anchor)}` : '';
    returnLink.href = `${context.returnUrl}${anchor}`;
  }

  const configureBrowseLink = (selector, item, label) => {
    const browseLink = document.querySelector(selector);
    if (!browseLink) return;
    if (!item) {
      browseLink.hidden = true;
      return;
    }
    browseLink.href = item.url;
    browseLink.hidden = false;
    browseLink.setAttribute('aria-label', item.title ? `${label}: ${item.title}` : label);
    const title = browseLink.querySelector('[data-product-browse-previous-title], [data-product-browse-next-title]');
    if (title) title.textContent = item.title;
  };

  const previousLabel = previousLink?.getAttribute('aria-label')?.split(':')[0] || 'Previous product';
  const nextLabel = nextLink?.getAttribute('aria-label')?.split(':')[0] || 'Next product';
  configureBrowseLink('[data-product-browse-previous]', context.items[currentIndex - 1], previousLabel);
  configureBrowseLink('[data-product-browse-next]', context.items[currentIndex + 1], nextLabel);

})();
